import api from 'app/base/axios';
import Request from 'app/base/request'

export function uploadFile(file) {
    const data = new FormData();
    data.append("file", file);
    return api.post(`file/upload`, data);
}

export function removeFile(fileId) {
    return api.delete(`file/remove/${fileId}`);
}

export function progress(guid) {
    return Request.get('file/progress/' + guid);
}

export function uploadLargeFile(url, file, guid, id, userId) {
    const data = new FormData();
    data.append("file", file);
    data.append("guid", guid);
    data.append("id", id);
    data.append("userId", userId);
    return Request.post(url, data, null, false);
}

export function removeLargeFile(url, fileId) {
    return Request.delete(url + '/' + fileId);
}